const state = {
  currentPageNumber: 1
}

const getters = {
  getCurrent: state => {
    return state.currentPageNumber
  }
}

const mutations = {
  decrement (state) {
    state.currentPageNumber--
  },
  increment (state) {
    state.currentPageNumber++
  },
  setPage (state, page) {
    state.currentPageNumber = page
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
